export const systemSettingsState = {
    name: 'app.system.settings',
    url: '/settings',
    component: 'system'
};
